module.exports = __webpack_public_path__ + "img/void.a5996e03.svg";